import LandingPage from '$lib/storyblok/pages/landingPage.svelte';
import LandingPageHero from '$lib/storyblok/blocks/landingPageHero.svelte';
import LandingPageModuleHeadline from '$lib/storyblok/blocks/landingPageModuleHeadline.svelte';
import defaultComponents from '$lib/storyblok/defaultComponents';
import LandingPageModuleHeadlineNyc from '$lib/storyblok/blocks/nycLp/landingPageModuleHeadlineNyc.svelte';
import LandingPageHeroNyc from '$lib/storyblok/blocks/nycLp/landingPageHeroNyc.svelte';
import YotpoReviewsWidget from '$lib/storyblok/blocks/yotpoReviewsWidget.svelte';
import BackgroundColorNyc from '$lib/storyblok/blocks/nycLp/homepageModules/backgroundColorNyc.svelte';
import SbButtonNyc from '$lib/storyblok/blocks/nycLp/sbButtonNyc.svelte';
import BoatsHeroModule from '$lib/storyblok/blocks/boats/heroModule.svelte';
import BoatsHeroNavigation from '$lib/storyblok/blocks/boats/heroNavigation.svelte';
import NavItem from '$lib/storyblok/blocks/homepage/navItem.svelte';
import NavButton from '$lib/storyblok/blocks/homepage/navButton.svelte';
import HowItWorksGallery from '$lib/storyblok/blocks/boats/howItWorksGallery.svelte';
import HowItWorksGalleryItem from '$lib/storyblok/blocks/boats/howItWorksGalleryItem.svelte';
import SideBySide from '$lib/storyblok/blocks/boats/sideBySide.svelte';
import wallOfLoveComponents from '$lib/storyblok/wallOfLoveComponents';
import LearnMoreAnchor from '$lib/storyblok/blocks/learnMoreAnchor.svelte';
import BoatsCollage from '$lib/storyblok/blocks/boats/foodGroundsCollage.svelte';
import FoodGroundsImageCard from '$lib/storyblok/blocks/boats/foodGroundsImageCard.svelte';
import LandingPageHeaderNyc from '$lib/storyblok/blocks/nycLp/landingPageHeaderNyc.svelte';
import LandingPageHeader from '$lib/storyblok/blocks/lpHeader.svelte';
import HowItWorksV2GalleryItem from '$lib/storyblok/blocks/howItWorksV2GalleryItem.svelte';
import HeroNavigation from '$lib/storyblok/blocks/homepage/heroNavigation.svelte';
import Testimonials from '$lib/storyblok/blocks/homepage/testimonials.svelte';
import EditorialExpand from '$lib/storyblok/blocks/editorialExpand.svelte';
import PdpHeroCarouselV2 from '$lib/storyblok/blocks/PdpHeroCarouselV2.svelte';
import PdpHeroV2 from '$lib/storyblok/blocks/pdpHeroV2.svelte';
import PdpHeroCarousel from '$lib/storyblok/blocks/PdpHeroCarousel.svelte';
import PdpHeroContent from '$lib/storyblok/blocks/pdpHeroContent.svelte';
import PdpHeroContentV2 from '$lib/storyblok/blocks/pdpHeroContentV2.svelte';
import PdpPrice from '$lib/storyblok/blocks/pdpPrice.svelte';
import { registerComponents } from '$lib/storyblok/sdk';
import HeroTeaser from '$lib/storyblok/blocks/heroTeaser.svelte';
import Timeline from '$lib/storyblok/blocks/timeline.svelte';
import AssetWithFacts from '$lib/storyblok/blocks/assetWithFacts.svelte';
import AssetWithFactsItem from '$lib/storyblok/blocks/assetWithFactsItem.svelte';

registerComponents({
	...defaultComponents,
	...wallOfLoveComponents,
	homepage_testimonials: Testimonials,
	landing_page: LandingPage,
	landing_page_hero: LandingPageHero,
	landing_page_module_headline: LandingPageModuleHeadline,
	//NYC Modules:
	landing_page_header_nyc: LandingPageHeaderNyc,
	landing_page_hero_nyc: LandingPageHeroNyc,
	yotpo_reviews_widget: YotpoReviewsWidget,
	landing_page_module_headline_nyc: LandingPageModuleHeadlineNyc,
	landing_page_river_card_nyc: import('$lib/storyblok/blocks/nycLp/landingPageRiverCardNyc.svelte'),
	landing_page_river_module_nyc: import(
		'$lib/storyblok/blocks/nycLp/landingPageRiverModuleNyc.svelte'
	),
	text_cta_nyc: import('$lib/storyblok/blocks/nycLp/textCtaNyc.svelte'),
	fullscreen_video_link_nyc: import('$lib/storyblok/blocks/nycLp/fullscreenVideoLinkNyc.svelte'),
	background_color_nyc: BackgroundColorNyc,
	sb_button_nyc: SbButtonNyc,
	how_it_works_v2_gallery_item: HowItWorksV2GalleryItem,
	editorial_expand: EditorialExpand,
	// Boats
	boats_hero_module: BoatsHeroModule,
	boats_how_it_works_gallery: HowItWorksGallery,
	boats_how_it_works_gallery_item: HowItWorksGalleryItem,
	side_by_side: SideBySide,
	learn_more_anchor: LearnMoreAnchor,
	boats_collage: BoatsCollage,
	food_grounds_image_card: FoodGroundsImageCard,
	// Header
	landing_page_header: LandingPageHeader,
	homepage_hero_navigation: HeroNavigation,
	homepage_floating_navigation: import('$lib/storyblok/blocks/homepage/floatingNavigation.svelte'),
	homepage_nav_item: NavItem,
	homepage_nav_button: NavButton,
	boats_hero_navigation: BoatsHeroNavigation,
	pdp_hero_carousel_v2: PdpHeroCarouselV2,
	pdp_hero_v2: PdpHeroV2,
	pdp_hero_carousel: PdpHeroCarousel,
	pdp_hero_content: PdpHeroContent,
	pdp_hero_content_v2: PdpHeroContentV2,
	pdp_price: PdpPrice,
	hero_teaser: HeroTeaser,
	timeline: Timeline,
	asset_with_facts: AssetWithFacts,
	asset_with_facts_item: AssetWithFactsItem,
});
